<template>
  <div class="content">
    <h1>Seattle Neighborhoods</h1>
    <ul class="l-grid l-grid-xsmall">
      <li v-for="neighborhood in neighborhoods">
        <router-link class="mini-card" :to="{name: 'neighborhood', params: {id: neighborhood.slug}}">{{ neighborhood.name }}</router-link>
      </li>
    </ul>
    <Geo :multipolygons="multipolygons"></Geo>
  </div>
</template>

<script>
import Geo from '@/components/Geo'

export default {
  name: 'neighborhoods',

  components: {
    'Geo': Geo
  },

  mounted: function () {
    this.$store.dispatch('neighborhoodsView/reset')
    this.$store.dispatch('neighborhoodsView/fetch')
  },

  computed: {
    neighborhoods () {
      return this.$store.getters['neighborhoodsView/get']
    },

    multipolygons () {
      let multipolygons = []
      let vm = this
      let defaultColor = vm.$store.getters.teal.dark.a

      this.neighborhoods.forEach(neighborhood => {
        multipolygons.push({
          data: neighborhood.multipolygon,
          options: {
            color: defaultColor,
            weight: 2
          },
          click: function (e) {
            vm.$router.push({name: 'neighborhood', params: {id: neighborhood.slug}})
          },
          mouseover: function (e) {
            this.setStyle({color: vm.$store.getters.orange.default})
          },
          mouseout: function (e) {
            this.setStyle({color: defaultColor})
          },
          tooltip: neighborhood.name
        })
      })

      return multipolygons
    }
  },

  watch: {
    $route: function (to, from) {
      this.$store.dispatch('neighborhoodsView/reset')
      this.$store.dispatch('neighborhoodsView/fetch')
    }
  },

  beforeRouteLeave (to, from, next) {
    document.getElementById('app').classList.remove('s-map-collapsed', 's-map-default', 's-map-medium', 's-map-full')
    next()
  }
}
</script>

<style lang="scss">
@import "./src/sass/components/geo.scss";
@import "./src/sass/components/mini-card.scss";
</style>



// WEBPACK FOOTER //
// Neighborhoods.vue?5e70dc85